// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-title[data-v-6a6c70f0] {\n  font-size: 32px;\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
